export const CHARGEBACK_HELP_URL =
  'https://ajuda.eduzz.com/hc/pt-br/articles/1260807649349-O-que-e-Chargeback-e-como-funcionam-seus-%C3%ADndices';

export const constants = {
  create: { alias: 'Criação' },
  receive: { alias: 'Pagamento' },
  click: { alias: 'Clique' },
  producer: { alias: 'Produtor' },
  coproducer: { alias: 'Co-produtor' },
  affiliate: { alias: 'Afiliado' },
  A: { alias: 'Assinatura' },
  N: { alias: 'Única' },
  G: { alias: 'Gratuito' },
  next: {
    alias: 'NEXT',
    url: 'https://next.eduzz.com'
  },
  INVOICES: 'INVOICES',
  CUSTOMER: 'CUSTOMER',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  AFFILIATES: 'AFFILIATES',
  MAIN_PRODUCTS: 'MAIN_PRODUCTS',
  TYPE_GAIN: 'TYPE_GAIN',
  UTMS: 'UTMS',
  VARIATIONS: 'VARIATIONS',
  COUPONS: 'COUPONS',
  STATUS: 'STATUS',
  PERIOD: 'PERIOD',
  OTHERS: 'OTHERS',
  SALE_FROM: 'SALE_FROM',
  TYPE_CHARGING: 'TYPE_CHARGING',
  CONTRACTS: 'CONTRACTS',

  // PRODUCT PARTNERS
  productPartners: {
    alumy: 36,
    blinket: 28
  },

  // PAYMENT STATUS
  PAYMENT_STATUS: {
    OPEN: 1,
    EXPIRED: 10,
    WAITING_PAYMENT: 15
  },

  PROVIDERS: {
    HOTMART: {
      ID: 4,
      PREPOSITION: 'da'
    },
    CUSTOM: {
      ID: 1,
      PREPOSITION: ''
    },
    LEADLOVERS: {
      ID: 12,
      PREPOSITION: 'do'
    },
    EADPLATAFORMA: {
      ID: 29,
      PREPOSITION: 'da'
    },
    APOLLO: {
      ID: 39,
      PREPOSITION: 'do'
    },
    WEVE: {
      ID: 48,
      PREPOSITION: 'da'
    }
  },

  PAYMENT_METHODS: {
    BANKSLIP: 1,
    CREDIT_CARD_ELO: 24,
    DUPLICATED_CREDIT_CARD_ELO: 10
  },

  // PRODUCT TYPES
  CLIENTS_CAN_EDIT_OVERDUE_LIMIT: [273925, 27270338],
  INFO: 1,
  SERVICE: 2,
  PHYSICAL: 3,
  TICKET: 4,
  BLINKET: 28,
  ALUMY: 36,
  SUBSCRIPTION: 99,
  links: {
    MoreInfoDashElite: 'https://programaelite.eduzz.com/',
    OldCheckout: 'https://g.eduzz.com/',
    CustomizeCheckout: 'https://adminsun.eduzz.com/',
    OrbitPage: 'https://app.orbitpag.es/eduzz',
    HelpLink: 'https://github.com/eduzz/custom-delivery',
    CustomizedDeliveryFAQ:
      'https://ajuda.eduzz.com/hc/pt-br/articles/4410578011547-como-cadastrar-a-entrega-de-um-conteúdo-customizado',
    RvpRules:
      'https://ajuda.eduzz.com/hc/pt-br/articles/1260807625289-como-funciona-a-recupera%C3%A7%C3%A3o-de-vendas-perdidas-rvp-'
  },
  TRANSFER_RATE_VALUE: 9.0,
  MINIMUN_VALUE_FOR_TRANSFER: 100,
  MIN_LINES_EXPORT_BACKBROUND_SALES: 1000,
  MAUTIC_AUTORESPONDER_ID: 35,
  HUBSPOT_WIDGET_URL:
    'https://meetings.hubspot.com/everton-cruz1/aceleracao-de-negocios-eduzz?uuid=6afb8f77-340a-46f2-9c3f-5754aad83dc1'
};

export const PF_TRANSFER_LIMIT = 2250;
export const MIN_TRANSFER = 20;
export const MIN_TRANSFER_INTERNATIONAL = 5500;

export enum ERebrandingColors {
  CONTRAST_TEXT = '#fff',
  DARK = '#37474F',
  LIGHT = '#9EB5D9',
  MAIN = '#0D2772'
}

export const FINANCIAL_BLOCK_TOOLTIP_MESSAGE =
  'Para solicitação de transferência bancaria contate suporte@eduzz.com ou contate seu gerente de contas.';
